<template>
  <div>
    <template v-if="handle.type !== 'Score Final'">
      <!-- Forcer la catégorie -->
      <b-form-group label="Force category" label-cols="3">
        <vue-typeahead-bootstrap
          ref="typeaheadTheme"
          inputName="theme"
          :showOnFocus="true"
          :data="themes"
          :maxMatches="1000"
          v-model="handle.theme"
          class="w-100" />
      </b-form-group>

      <!-- Intro audio -->
      <b-form-group label="Intro audio" label-cols="3">
        <AudioSelector
          :initial-audio="{
            name: handle.audio,
            path: handle.audioUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onAudioUploaded($event)"
          @file-selected="onFileSelected($event, 'audio', 'audioPath', 'audioUrl')" />
      </b-form-group>

      <!-- Video Intro -->
      <b-form-group v-if="handle.type !== 'Score'" label="Intro video" label-cols="3">
        <VideoSelector
          :initial-video="{
            name: handle.video,
            path: handle.videoUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onVideoUploaded($event)"
          @file-selected="onFileSelected($event, 'video', 'videoPath', 'videoUrl')" />
      </b-form-group>

      <!-- Musique (score) -->
      <b-form-group v-if="handle.type === 'Score'" label="Music" label-cols="3">
        <AudioSelector
          :initial-audio="{
            name: handle.music,
            path: handle.musicUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onAudioUploaded($event)"
          @file-selected="onFileSelected($event, 'music', 'musicPath', 'musicUrl')" />
      </b-form-group>

      <!-- Image de fond -->
      <b-form-group label="Background picture" label-cols="3">
        <ImageSelector
          :initial-image="{
            name: handle.screenPicture,
            path: handle.screenPictureUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onImageUploaded($event)"
          @file-selected="onFileSelected($event, 'screenPicture', 'screenPicturePath', 'screenPictureUrl')" />
      </b-form-group>

      <!-- Image podium -->
      <b-form-group
        v-if="handle.type === 'Blindtest' || handle.type === 'Juste Prix'"
        label="Podium image"
        label-cols="3">
        <ImageSelector
          :initial-image="{
            name: handle.podiumImage,
            path: handle.podiumImageUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onImageUploaded($event)"
          @file-selected="onFileSelected($event, 'podiumImage', 'podiumImagePath', 'podiumImageUrl')" />
      </b-form-group>

      <!-- Image Bouton Moins -->
      <b-form-group v-if="handle.type === 'Juste Prix'" label="Minus button image" label-cols="3">
        <ImageSelector
          :initial-image="{
            name: handle.minusButtonImage,
            path: handle.minusButtonImageUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onImageUploaded($event)"
          @file-selected="onFileSelected($event, 'minusButtonImage', 'minusButtonImagePath', 'minusButtonImageUrl')" />
      </b-form-group>

      <!-- Image Bouton Plus -->
      <b-form-group v-if="handle.type === 'Juste Prix'" label="Plus button image" label-cols="3">
        <ImageSelector
          :initial-image="{
            name: handle.plusButtonImage,
            path: handle.plusButtonImageUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onImageUploaded($event)"
          @file-selected="onFileSelected($event, 'plusButtonImage', 'plusButtonImagePath', 'plusButtonImageUrl')" />
      </b-form-group>

      <!-- Afficher les propositions (classique) -->
      <b-form-group v-if="handle.type === 'Classique'" label="Show answers" label-cols="3">
        <div class="form-check">
          <select
            :value="handle.proposalType"
            class="form-control form-control-sm"
            :disabled="loading"
            @input="updateModelAttribute('proposalType', $event.target.value)">
            <option value="end_of_sound">Show suggested answers after the question sound</option>
            <option value="same_time_of_sound">Show suggested answers at the same time as the question sound</option>
          </select>
        </div>
      </b-form-group>

      <!-- Durée (en s) -->
      <b-form-group
        v-if="
          handle.type === 'Classique' ||
          handle.type === 'Binaire' ||
          handle.type === 'Blindtest' ||
          handle.type === 'Juste Prix'
        "
        label="Duration (in s)"
        label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.handleTime"
          @input="
            updateModelAttribute('handleTime', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Temps pour répondre (en s) -->
      <b-form-group v-if="handle.type !== 'Score'" label="Time to answer(in s)" label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.questionTime"
          @input="
            updateModelAttribute('questionTime', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Temps réponse/score (en s) -->
      <b-form-group
        v-if="handle.type === 'Classique' || handle.type === 'Juste Prix'"
        label="Response time/score (in s)"
        label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.responseDefaultTime"
          @input="
            updateModelAttribute('responseDefaultTime', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Points succès -->
      <b-form-group
        v-if="handle.type === 'Classique' || handle.type === 'Binaire' || handle.type === 'Juste Prix'"
        label="Correct answer points"
        label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.pointUp"
          @input="
            updateModelAttribute('pointUp', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Points à 1 valeur près -->
      <b-form-group v-if="handle.type === 'Juste Prix'" label="Points earned for being within 1 digit" label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.pointApproxOne"
          @input="
            updateModelAttribute('pointApproxOne', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Points à 2 valeurs près -->
      <b-form-group v-if="handle.type === 'Juste Prix'" label="Points earned for being within 2 digits" label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.pointApproxTwo"
          @input="
            updateModelAttribute('pointApproxTwo', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Points échec -->
      <b-form-group
        v-if="handle.type === 'Classique' || handle.type === 'Binaire' || handle.type === 'Juste Prix'"
        label="Wrong answer points"
        label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.pointDown"
          @input="
            updateModelAttribute('pointDown', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Points 1er -->
      <b-form-group v-if="handle.type === 'Blindtest'" label="1st place points" label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.pointFirst"
          @input="
            updateModelAttribute('pointFirst', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Points 2eme -->
      <b-form-group v-if="handle.type === 'Blindtest'" label="2nd place points" label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.pointSecond"
          @input="
            updateModelAttribute('pointSecond', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Points 3eme -->
      <b-form-group v-if="handle.type === 'Blindtest'" label="3rd place points" label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.pointThird"
          @input="
            updateModelAttribute('pointThird', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>
    </template>

    <template v-if="handle.type === 'Score Final'">
      <h4 class="my-4">Intro</h4>

      <!-- Intro Audio -->
      <b-form-group label="Intro audio" label-cols="3">
        <AudioSelector
          :initial-audio="{
            name: handle.audioIntro,
            path: handle.audioIntroUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onAudioUploaded($event)"
          @file-selected="onFileSelected($event, 'audioIntro', 'audioIntroPath', 'audioIntroUrl')" />
      </b-form-group>

      <!-- Image de fond -->
      <b-form-group label="Background picture" label-cols="3">
        <ImageSelector
          :initial-image="{
            name: handle.screenPictureIntro,
            path: handle.screenPictureIntroUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onImageUploaded($event)"
          @file-selected="
            onFileSelected($event, 'screenPictureIntro', 'screenPictureIntroPath', 'screenPictureIntroUrl')
          " />
      </b-form-group>

      <hr />
      <h4 class="my-4">Display of the player who won the most points with jokers</h4>

      <!-- Audio -->
      <b-form-group label="Audio" label-cols="3">
        <AudioSelector
          :initial-audio="{
            name: handle.audioJokerWinner,
            path: handle.audioJokerWinnerUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onAudioUploaded($event)"
          @file-selected="onFileSelected($event, 'audioJokerWinner', 'audioJokerWinnerPath', 'audioJokerWinnerUrl')" />
      </b-form-group>

      <!-- Image de fond -->
      <b-form-group label="Background picture" label-cols="3">
        <ImageSelector
          :initial-image="{
            name: handle.screenPictureJokerWinner,
            path: handle.screenPictureJokerWinnerUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onImageUploaded($event)"
          @file-selected="
            onFileSelected(
              $event,
              'screenPictureJokerWinner',
              'screenPictureJokerWinnerPath',
              'screenPictureJokerWinnerUrl'
            )
          " />
      </b-form-group>

      <hr />
      <h4 class="my-4">Display of the player who lost the most points with jokers</h4>

      <!-- Audio -->
      <b-form-group label="Audio" label-cols="3">
        <AudioSelector
          :initial-audio="{
            name: handle.audioJokerLoser,
            path: handle.audioJokerLoserUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onAudioUploaded($event)"
          @file-selected="onFileSelected($event, 'audioJokerLoser', 'audioJokerLoserPath', 'audioJokerLoserUrl')" />
      </b-form-group>

      <!-- Image de fond -->
      <b-form-group label="Background picture" label-cols="3">
        <ImageSelector
          :initial-image="{
            name: handle.screenPictureJokerLoser,
            path: handle.screenPictureJokerLoserUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onImageUploaded($event)"
          @file-selected="
            onFileSelected(
              $event,
              'screenPictureJokerLoser',
              'screenPictureJokerLoserPath',
              'screenPictureJokerLoserUrl'
            )
          " />
      </b-form-group>

      <hr />
      <h4 class="my-4">Podium display</h4>

      <!-- Audio -->
      <b-form-group label="Audio" label-cols="3">
        <AudioSelector
          :initial-audio="{
            name: handle.audioPodium,
            path: handle.audioPodiumUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onAudioUploaded($event)"
          @file-selected="onFileSelected($event, 'audioPodium', 'audioPodiumPath', 'audioPodiumUrl')" />
      </b-form-group>

      <!-- Image de fond -->
      <b-form-group label="Background picture" label-cols="3">
        <ImageSelector
          :initial-image="{
            name: handle.screenPicturePodium,
            path: handle.screenPicturePodiumUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onImageUploaded($event)"
          @file-selected="
            onFileSelected($event, 'screenPicturePodium', 'screenPicturePodiumPath', 'screenPicturePodiumUrl')
          " />
      </b-form-group>

      <!-- Délai avant l'apparition du joueur en 3e position (en s) -->
      <b-form-group label="Delay before the player shows in 3rd position (in s)" label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.timePodiumStarts"
          @input="
            updateModelAttribute('timePodiumStarts', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Durée d'affichage joueur 3ème position (en s) -->
      <b-form-group label="3rd position player display duration (in s)" label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.timePodiumThird"
          @input="
            updateModelAttribute('timePodiumThird', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Score final - durée d'affichage joueur 2eme position (en s) -->
      <b-form-group label="2nd position player display duration (in s)" label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.timePodiumSecond"
          @input="
            updateModelAttribute('timePodiumSecond', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <!-- Score final - durée d'affichage joueur 1er position (en s) -->
      <b-form-group label="1st position player display duration (in s)" label-cols="3">
        <input
          type="number"
          class="form-control form-control-sm"
          :disabled="loading"
          :value="handle.timePodiumFirst"
          @input="
            updateModelAttribute('timePodiumFirst', $event.target.value, {
              isNumber: true,
            })
          " />
      </b-form-group>

      <hr />
      <h4 class="my-4">Total score display</h4>

      <!-- Audio -->
      <b-form-group label="Audio" label-cols="3">
        <AudioSelector
          :initial-audio="{
            name: handle.audioFinal,
            path: handle.audioFinalUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onAudioUploaded($event)"
          @file-selected="onFileSelected($event, 'audioFinal', 'audioFinalPath', 'audioFinalUrl')" />
      </b-form-group>

      <!-- Image de fond -->
      <b-form-group label="Background picture" label-cols="3">
        <ImageSelector
          :initial-image="{
            name: handle.screenPictureFinal,
            path: handle.screenPictureFinalUrl,
          }"
          buttons-position="right"
          empty-container-action="import"
          :disabled="loading"
          @file-uploaded="onImageUploaded($event)"
          @file-selected="
            onFileSelected($event, 'screenPictureFinal', 'screenPictureFinalPath', 'screenPictureFinalUrl')
          " />
      </b-form-group>
    </template>
  </div>
</template>

<script>
  import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
  import AudioSelector from '@/components/file/AudioSelector.vue'
  import VideoSelector from '@/components/file/VideoSelector.vue'
  import ImageSelector from '@/components/file/ImageSelector.vue'

  export default {
    name: 'HandleCard',
    props: {
      value: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
      },
      gameId: {
        type: String,
        required: true,
      },
      themes: {
        type: Array,
        default: () => [],
      },
      videos: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      VueTypeaheadBootstrap,
      AudioSelector,
      VideoSelector,
      ImageSelector,
    },
    computed: {},
    data() {
      return {
        handle: this.value,
        loading: false,
      }
    },
    mounted() {
      this.setupTypeaheadInput()
    },
    methods: {
      /**
       * Setup le typeahead pour le champ de catégorie
       */
      setupTypeaheadInput() {
        if (!this.$refs.typeaheadTheme) {
          return
        }

        let input = this.$refs.typeaheadTheme.$el.querySelector('input')

        if (input) {
          input.setAttribute('autocomplete', 'off')
          input.setAttribute('required', 'true')
        }
      },

      /**
       * Événement audio uploadé
       */
      onAudioUploaded(file) {
        this.$emit('audioUploaded', file)
      },

      /**
       * Événement vidéo uploadé
       */
      onVideoUploaded(file) {
        this.$emit('videoUploaded', file)
      },

      /**
       * Événement image uploadé
       */
      onImageUploaded(file) {
        this.$emit('imageUploaded', file)
      },

      /**
       * Événement fichier sélectionné
       */
      onFileSelected(file, fieldname = null, fieldpath = null, fieldurl = null) {
        console.log('onFileSelected', file, fieldname, fieldpath, fieldurl)
        if (!file) {
          if (fieldname) this.$set(this.handle, fieldname, null)
          if (fieldpath) this.$set(this.handle, fieldpath, null)
          if (fieldurl) this.$set(this.handle, fieldurl, null)
          return
        }

        if (fieldname) this.$set(this.handle, fieldname, file.name)
        if (fieldpath) this.$set(this.handle, fieldpath, file.path)
        if (fieldurl) this.$set(this.handle, fieldurl, file.url)
      },

      /**
       * Met à jour un attribut de la manche
       */
      updateModelAttribute(attribute, _value, { isNumber = false } = {}) {
        let value = _value
        if (isNumber) {
          value = this.trimLeadingChars(value)
          value = this.trimTrailingChars(value)
          value = Number(value)
        }

        this.handle[attribute] = value
        this.emitModel()
      },

      /**
       * Émet l'événement du model pour le parent
       */
      emitModel() {
        this.$emit('input', this.handle)
      },

      /**
       * Supprime les caractères de début
       */
      trimLeadingChars(val) {
        if (!val) {
          return ''
        }

        for (let i = 0; i < val.length; i += 1) {
          if (!Number.isNaN(val[i])) {
            return val.slice(i)
          }
        }

        return val
      },

      /**
       * Supprime les caractères de fin
       */
      trimTrailingChars(val) {
        if (!val) {
          return ''
        }

        for (let i = val.length - 1; i >= 0; i -= 1) {
          if (!Number.isNaN(Number(val[i]))) {
            return val.slice(0, i + 1)
          }
        }

        return val
      },
    },
  }
</script>
